import React from 'react'
import {Row, Col, Icon} from 'antd'
import "./style/index.less";

class App extends React.Component {

  static defaultProps = {
    more: true,
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  getMore = () => {
    typeof this.props.getMore === 'function' && this.props.getMore()
  }

  render() {
    const { simple, title = '', tabs = [], onMouseOver, selectedKey = '', showTabs = false, span = 20, offset = 2, style, more} = this.props;
    return (
      <Row className='cs-tabs' style={style}>
        <Col span={span} offset={offset} className={`tab-title${simple ? '-simple' : ''}`}>
          <Row>
            <Col span={more ? 21 : 24}>
              {
               !simple && (
                 <Icon type="minus" className='tab-icon'/>
               )
              }
              <div className='tab-text'>{title}</div>
              <div className='tab-sub-titles'>
                {
                  showTabs && tabs && tabs.map(item => {
                    return (
                      <div key={item.key}
                           className={`tab-sub-title ${selectedKey === item.key && 'tab-sub-title-active'}`}
                           onMouseOver={() => {
                             typeof onMouseOver === 'function' && onMouseOver(item.key)
                           }}>
                        {item.name}
                      </div>
                    )
                  })
                }
              </div>
            </Col>
            {
              more && <Col span={3}>
                <div className='tab-more' onClick={this.getMore}>
                  <span>更多</span>
                  <Icon type="double-right"/>
                </div>
              </Col>
            }
          </Row>
        </Col>
      </Row>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/tab/index.js